import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionBar = ({ selectedCount, onBulkAction, onSelectAll, allSelected }) => {
  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <button
          onClick={onSelectAll}
          className="p-2 rounded-md hover:bg-primary/20 transition-smooth"
          aria-label={allSelected ? 'Deselect all' : 'Select all'}
        >
          <Icon name={allSelected ? 'CheckSquare' : 'Square'} size={20} color="var(--color-primary)" />
        </button>
        <span className="text-sm font-medium text-primary">
          {selectedCount} candidate{selectedCount !== 1 ? 's' : ''} selected
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('Shortlist')}
          iconName="CheckCircle"
          iconPosition="left"
        >
          Shortlist
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('Send Email')}
          iconName="Mail"
          iconPosition="left"
        >
          Send Email
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('Export')}
          iconName="Download"
          iconPosition="left"
        >
          Export
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkAction('Reject')}
          iconName="XCircle"
          iconPosition="left"
        >
          Reject
        </Button>
      </div>
    </div>
  );
};

export default BulkActionBar;